import { EPermissions } from '@/types/permissions.types';
import { BLAdmin } from '@/types/profile.types';
import userHasRoleOnActiveChannel from './user-has-role-on-active-channel';

const canAddSessionToProject = (user?: BLAdmin | null) => {
  const allowedRoles = [
    EPermissions.Owner,
    EPermissions.Admin,
    EPermissions.Builder,
    EPermissions.GroupAdmin,
    EPermissions.Editor,
  ];

  const hasPermission = userHasRoleOnActiveChannel(allowedRoles, user);

  return hasPermission;
};

export default canAddSessionToProject;
